import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { AuthGate } from "@/components/AuthGate";
import { AppLayout } from "@/layouts/AppLayout";
import { FleetPage } from "@/pages/FleetPage";
import { DevicesPage } from "@/pages/DevicesPage";
import { DeploysPage } from "@/pages/DeploysPage";
import { AppsPage } from "@/pages/AppsPage";
import { SetupPage } from "@/pages/SetupPage";
import { DocsPage } from "@/pages/DocsPage";
import { AgentPage } from "@/pages/AgentPage";

const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "syncstack.us.auth0.com";
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || "";
const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || "https://api.syncstack.ai";

export function App() {
  return (
    <BrowserRouter>
      <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: AUTH0_AUDIENCE,
          scope: "openid profile email",
        }}
      >
        <AuthGate>
          <Routes>
            <Route path="/" element={<Navigate to="/fleet" replace />} />
            <Route element={<AppLayout />}>
              <Route path="/fleet" element={<FleetPage />} />
              <Route path="/devices" element={<DevicesPage />} />
              <Route path="/deploys" element={<DeploysPage />} />
              <Route path="/apps" element={<AppsPage />} />
              <Route path="/agent" element={<AgentPage />} />
              <Route path="/setup" element={<SetupPage />} />
              <Route path="/docs" element={<DocsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/fleet" replace />} />
          </Routes>
        </AuthGate>
      </Auth0Provider>
    </BrowserRouter>
  );
}
